 import css from '../images/CSS.svg';
 import js from '../images/js.png';
 import ml from '../images/ml.png';
 import cpp from '../images/cpp.svg';
 import py from '../images/python.png';
 import java from '../images/java.svg';
 import conda from '../images/anaconda.png';
 import php from '../images/php.png'
 import html from '../images/html.svg'
 const skill =[
    {
        name : "HTML",
        bg : "tomato",
        iconLink : html,
        width: "90%",
        alt: "html ",
        percent : "90%"
    },
    {
        name : "CSS",
        bg: "teal",
        iconLink : css,
        width: "90%",
        alt: "html ",
        percent : "90%"
    },
    {
        name : "JavaScript",
        bg: "#fce205",
        iconLink : js,
        width: "90%",
        alt: "java script",
        percent : "90%"
    },
    {
        name : "C/C++",
        bg: "#152238",
        iconLink : cpp,
        width: "90%",
        alt: "CPP",
        percent : "90%"
    }, {
        name : "JAVA",
        bg: "#9e1a1a",
        iconLink : java,
        width: "60%",
        alt: "JAVA",
        percent : "60%"
    },{
        name : "PYTHON",
        bg: "#059142",
        iconLink : py,
        width: "80%",
        alt: "html ",
        percent : "90%"
    },
    {
        name : "Machine Learning",
        bg: "teal",
        iconLink : ml,
        width: "60%",
        alt: "machine learning",
        percent : "60%"
    },
    {
        name : "Anaconda",
        bg: "#222222",
        iconLink : conda,
        width: "90%",
        alt: "html",
        percent : "90%"
    },
    {
        name : "PHP",
        bg: "#474a8a",
        iconLink : php,
        width: "90%",
        alt: "html",
        percent : "90%"
    }
]
export default skill;
